import { IconButton, Stack, Typography } from "@mui/material";
import { useRouter } from "next/router";
import React, { FC } from "react";
import CommonSvg, { svgNames } from "../CommonSvg";
import { useTranslation } from "next-i18next";

interface IMobileHeaderProps {
  title: string;
  titleCentered?: boolean;
  backBtn?: boolean;
  onBack?: Function;
  extraInfo?: React.ReactNode;
}

const MobileHeader: FC<IMobileHeaderProps> = ({
  title,
  titleCentered = true,
  backBtn = true,
  onBack,
  extraInfo,
}) => {
  const router = useRouter();
  const { t } = useTranslation("common");

  const go_back = () => {
    if (onBack) {
      onBack();
    } else {
      router.back();
    }
  };

  return (
    <Stack spacing={2} direction={"row"} alignItems={"center"} justifyContent={"space-between"} mb={1}>
      {backBtn && (
        <IconButton onClick={go_back} disableRipple>
          <CommonSvg name={svgNames.ArrowLeft} />
        </IconButton>
      )}
      <Typography variant="h5">{title}</Typography>
      <div style={{minWidth:"40px"}}>
      {extraInfo}
      </div>
    </Stack>
  );
};

export default MobileHeader;
